<div class="dialog-video">
  <div class="dialog-video__close-button">
    <button mat-icon-button matTooltip="Close video" (click)="close()">
      <mat-icon data-ga-value="dialog-video-button">close</mat-icon>
    </button>
  </div>
  <div class="dialog-video__container">
    <video controls autoplay="true">
      <source [src]="data.videoUrl" />
      <source />
    </video>
  </div>
</div>
